import React, { useState, useEffect } from "react";
import Select from "react-dropdown-select";
import { useLazyQuery } from "react-apollo";
import { toast } from "react-toastify";
import { CleanMessage } from "../util/app";
import LoadingSpinner from "./loading";
import { GET_STAFF_DESIGNATION } from "../queries/staff.query";

const UserByDesignationDropdown = ({ onChange, designation }) => {
    const [users, setUsers] = useState([]);

    const [getStaffFunc, { loading }] = useLazyQuery(GET_STAFF_DESIGNATION, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.GetStaffByDesignation) {
                const { docs } = d.GetStaffByDesignation;
                setUsers(
                    docs.map(c => ({
                        id: c.id,
                        name: `${c.surname} ${c.first_name}`
                    }))
                );
            }
        }
    });
    useEffect(() => {
        if (designation) getStaffFunc({ variables: { designation } });
    }, [getStaffFunc, designation]);
    return (
        <>
            <LoadingSpinner loading={loading} bar={true} />
            <Select
                options={users}
                multi={false}
                valueField="id"
                labelField="name"
                onChange={values => onChange(values[0])}
                searchable={true}
                color="#0066f5 "
                searchBy="name"
                clearable={true}
                separator={true}
                placeholder="Select Staff"
            />
        </>
    );
};

export default UserByDesignationDropdown;
